<template>
    <div class="portfolio-coordinator">
        <design-2021-apprentice-multistep-form-wizard-form-header-component
            :title="$t('group.create.administrators')"
            :description="description">
        </design-2021-apprentice-multistep-form-wizard-form-header-component>

        <b-form-group
            class="project-coordinators-group"
            :label="$t('group.create.add_administrators')">
            <design-2021-apprentice-multiselect-component
                class="apprentice-primary-select coordinators-selects"
                id="settings-coordinators-multi-select"
                v-model="selectedTeachers"
                ref="teachersMultiSelect"
                :multiple-select="true"
                track-by="id"
                label="full_name"
                :options="teachers"
                :allow-empty="true"
                @input="updateTeachers">
            </design-2021-apprentice-multiselect-component>

            <design-2021-apprentice-data-table
                :fields="fields"
                :items="selectedTeachers">
                <template v-slot:cell(can_edit_permissions)="data">
                    <div class="add_to_project">
                        <b-button
                            class="btn-hand-pointer btn-user-selection-toggle"
                            :class="data.item.can_edit_permissions && 'active'"
                            variant="primary-icon-only"
                            @click="toggleCanEditPermissions(data.item)">
                        </b-button>
                        <!--                            <b-form-checkbox switch :key="data.item.id" v-model="data.item.selected"></b-form-checkbox>-->
                    </div>
                </template>
                <template v-slot:cell(can_edit_portfolio)="data">
                    <div class="add_to_project">
                        <b-button
                            class="btn-hand-pointer btn-user-selection-toggle"
                            :class="data.item.can_edit_portfolio && 'active'"
                            variant="primary-icon-only"
                            @click="toggleCanEditPortfolio(data.item)">
                        </b-button>
                        <!--                            <b-form-checkbox switch :key="data.item.id" v-model="data.item.selected"></b-form-checkbox>-->
                    </div>
                </template>
            </design-2021-apprentice-data-table>
        </b-form-group>
    </div>
</template>

<script>
    import Design2021ApprenticeMultiselectComponent from '../../../../common/design-2021-apprentice-multiselect-component.vue';

    export default {
        name: 'design-2021-apprentice-multistep-wizard-project-coordinators-step-component',
        components: { Design2021ApprenticeMultiselectComponent },
        props: {
            value: Array,
            teachersIn: {
                type: Array,
                required: true,
            },
            portfolio: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                description: this.$t('group.create.add_administrators_explanation'),
                selectedTeachers: [],
            };
        },
        computed: {
            teachers() {
                return this.teachersIn.map((teacher) => {
                    teacher.can_edit_portfolio = false;
                    teacher.can_edit_permissions = false;
                    return teacher;
                });
            },
            fields() {
                let fields = [
                    {
                        key: 'full_name',
                        label: this.$t('common.teacher'),
                    },
                    {
                        key: 'can_edit_permissions',
                        label: this.$t('group.create.can_authorize_teachers'),
                    },
                ];

                if (this.portfolio) {
                    fields.push({
                        key: 'can_edit_portfolio',
                        label: this.$t('group.create.can_edit_assignments'),
                    });
                }

                return fields;
            },
        },

        mounted() {
            let authTeacher = this.teachers.find((teacher) => teacher.id === this.$authUser.id);
            if (authTeacher) {
                authTeacher.can_edit_permissions = true;
                authTeacher.can_edit_portfolio = true;
                this.selectedTeachers.push(authTeacher);
            }
            if (this.selectedTeachers.length > 0) {
                this.$emit('input', this.selectedTeachers);
            }
        },

        methods: {
            updateTeachers() {
                this.$emit('input', this.selectedTeachers);
            },
            toggleCanEditPermissions(selectedTeacher) {
                selectedTeacher.can_edit_permissions = !selectedTeacher.can_edit_permissions;
                this.updateTeachers();
            },
            toggleCanEditPortfolio(selectedTeacher) {
                selectedTeacher.can_edit_portfolio = !selectedTeacher.can_edit_portfolio;
                this.updateTeachers();
            },
        },
    };
</script>

<style scoped lang="scss">
    .coordinators-selects {
        padding: 0;
    }

    .btn-user-selection-toggle {
        color: grayscale(var(--primary));

        &.active {
            color: var(--primary);
        }
    }
</style>
